import { makeStyles } from '@material-ui/core';
import { useRoutes } from 'react-router-dom';
import { InspectionCreationWizard } from './asset/editor/InspectionCreationWizard';
import { AssetList } from './asset/list/AssetList';
import { Dashboard } from './dashboard/Dashboard';
import { Header, Sidebar } from './global';
import { Event } from './global/event/Event';
import { ProjectList } from './project/list/ProjectList';
import { ReportRouter } from './report/ReportRouter';

const useAppClasses = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
    },
    content: {
        display: 'flex',
        flex: 1,
    },
});

export const App = () => {
    const classes = useAppClasses();
    const element = useRoutes([
        { path: '/', element: <Dashboard /> },
        { path: '/assets', element: <AssetList /> },
        { path: '/projects', element: <ProjectList /> },
        { path: '/plans', children: [{ path: '/create', element: <InspectionCreationWizard /> }] },
        { path: '/reports/*', element: <ReportRouter /> },
    ]);

    return (
        <div className={classes.root}>
            <Header />
            <div className={classes.content}>
                <Sidebar />
                {element}
            </div>
            <Event />
        </div>
    );
};
